var Mock = require('mockjs');

var user = {
  code: 0,
  data: {
    account: {
      auths: [],
      bank: '',
      bankCard: '',
      bankCardName: '',
      idCard: '',
      idCardImages: [],
      locked: false,
      name: 'admin-mall',
      phone: '110',
      photo: 9,
      role: 'admin',
      zfb: ''
    },
    package: {
      warehouse: 0
    },
    settings: {
      code: 'umishangcheng',
      lastAddress: '',
      superCode: '',
      superId: ''
    },
    time: {
      create: new Date().getTime(),
      signIn: new Date().getTime(),
      update: new Date().getTime()
    },
    wx: {
      _id: '5d02855a780dfe4fd0223a31'
    }
  }
}
export default {

}



// WEBPACK FOOTER //
// ./src/API/mock.js